import {CSSProperties, FC} from 'react'
import {useSelector} from 'react-redux'
import {useThemeMode} from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

export const Required: FC<{styles: CSSProperties; styleIcon?: CSSProperties; className?: string}> = ({
  styles = {top: 0, left: 5},
  styleIcon ={fontSize: 10},
  className = '',
}) => {
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const {mode} = useThemeMode()

  return (
    <>
      {!Submitted && (
        <div className={className} style={styles} data-bs-theme={mode}>
          <i className='fa fa-star-of-life text-danger' style={styleIcon}></i>
        </div>
      )}
    </>
  )
}
